import { Table } from 'antd'
import { VisorReporteOrdenCompra } from 'hooks/compras/useGenerarOrden'
import UseOrdenCompraEdit from 'hooks/compras/UseOrdenCompraEdit'
import { useVT } from 'virtualizedtableforantd4'
import "../../pages/productos/VisorMartillo.css"

interface ordenCompraEdi {
  dataProductosOrden: VisorReporteOrdenCompra[],
  setdataProductosOrden:Function,
  getDataBodega: Function,
  setLoader: Function,
  OnChangeSelectionProveedor: Function,
  SumProveedorOrdenCompra:Function

  //setselectkeyProveedor: Function
  //rowSelections: TableRowSelection<VisorReporteOrdenCompra>,
  //onRowClick: (record: VisorReporte, index?: number) => React.HTMLAttributes<any>
  //onChangeOrden: TableProps<VisorReporteOrdenCompra>['onChange']
 //handleSelectionChangeOrden:Function

}

export default function OrdenCompraEdit({dataProductosOrden, setdataProductosOrden, getDataBodega, setLoader, OnChangeSelectionProveedor, SumProveedorOrdenCompra}:ordenCompraEdi) {

    const {columns_orden, vtRef, tableRef, rowSelection, onRowClick}=UseOrdenCompraEdit(dataProductosOrden, setdataProductosOrden, getDataBodega, setLoader, OnChangeSelectionProveedor, SumProveedorOrdenCompra)
    const [vt] = useVT(() => ({ scroll: {y: "49vh"}, ref: vtRef /*, overscanRowCount: 20 */ }), [])
    //const {rowSelection, onRowClick}=useVisorMartillo()


  return (
    <>
     <Table
            ref={tableRef}
            components={vt}
            pagination={false}
            columns={columns_orden}
            scroll={{ x: 900, y: "49vh" }}
            size='small'
            dataSource={dataProductosOrden}
            bordered
            rowSelection={rowSelection}
            onRow={onRowClick}
            className='custom-table-visor'
            //onChange={onChangeOrden}
          />
    </>
  )
}
